import { render, staticRenderFns } from "./seguro-combinada-tooltip.vue?vue&type=template&id=a94f5c64&scoped=true&"
import script from "./seguro-combinada-tooltip.vue?vue&type=script&lang=js&"
export * from "./seguro-combinada-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./seguro-combinada-tooltip.vue?vue&type=style&index=0&id=a94f5c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94f5c64",
  null
  
)

export default component.exports